import { useState } from "react";

import axios from "axios";
import { useNavigate } from "react-router-dom";

import { ForgotPassword } from "./ForgotPassword";
import { validateEmail } from "../../../../utils";

import type { ForgotPasswordData } from "./types";

export function ForgotPasswordContainer() {
  const [form, setForm] = useState<ForgotPasswordData>({
    email: "",
  });
  const [error, setError] = useState<string | null>(null);

  const navigate = useNavigate();

  const handleFormChange = (key: keyof ForgotPasswordData, value: string) => {
    setError(validateEmail(value));
    setForm((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleForgotPassword = () => {
    const { email } = form;
    axios
      .post(`${import.meta.env.REACT_APP_API_URL}/forgot-password`, {
        email,
      })
      .then(() => {
        navigate("/confirm-forgot-password");
      })
      .catch((e) => {
        setError(
          e?.response?.data?.message ??
            "Failed to start forgot password flow. Please contact us.",
        );
      });
  };

  return (
    <ForgotPassword
      onForgotPassword={handleForgotPassword}
      error={error}
      onFormChange={handleFormChange}
      disableSendPassword={form.email.length === 0 || error !== null}
    />
  );
}
